import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  putBlockMatchById,
  type PutBlockMatchByIdParams,
  type PutBlockMatchByIdResponse,
} from '@services/MatchesService';

export type UsePutBlockMatchByIdParams = {
  mutationOptions?: SWRMutationConfiguration<
    PutBlockMatchByIdResponse,
    unknown,
    string,
    PutBlockMatchByIdParams,
    PutBlockMatchByIdResponse
  >;
};

export const putBlockMatchByIdMutationKey = 'put-block-match-by-id';

export const usePutBlockMatchById = ({
  mutationOptions,
}: UsePutBlockMatchByIdParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PutBlockMatchByIdResponse,
    unknown,
    string,
    PutBlockMatchByIdParams
  >(
    putBlockMatchByIdMutationKey,
    (_url, { arg }) => putBlockMatchById(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
